import React, { useCallback, useEffect, useState } from 'react';
import { fetchAllSpecialists, fetchPendingSpecialists, fetchSpecialistPlanilla, saveSpecialistPlanilla } from '../../services/adminService';
import AdminSpecialistPlanilla from './AdminSpecialistPlanilla';

const AdminPreapproveSpecialists = ({ solicitanteId, onClose, onUsar }) => {
  const [lista, setLista] = useState([]);
  const [elegido, setElegido] = useState('');
  const [modo, setModo] = useState('pendientes');
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [planilla, setPlanilla] = useState(null);
  const [planillaAbierta, setPlanillaAbierta] = useState(false);
  const [cargandoPlanilla, setCargandoPlanilla] = useState(false);
  const [errorPlanilla, setErrorPlanilla] = useState('');
  const [guardandoPlanilla, setGuardandoPlanilla] = useState(false);
  const [avisoPlanilla, setAvisoPlanilla] = useState('');

  const cargar = useCallback(
    (modoLista) => {
      const consulta = modoLista === 'todos' ? fetchAllSpecialists : fetchPendingSpecialists;

      setCargando(true);
      setError('');

      return consulta(solicitanteId)
        .then((especialistas) => {
          setLista(especialistas);
          setElegido('');
        })
        .catch((requestError) => {
          setLista([]);
          setError(requestError.message || 'No se pudieron cargar las planillas.');
        })
        .finally(() => {
          setCargando(false);
        });
    },
    [solicitanteId]
  );

  useEffect(() => {
    cargar('pendientes');
  }, [cargar]);

  const cambiarModo = (siguiente) => {
    setModo(siguiente);
    setPlanillaAbierta(false);
    setPlanilla(null);
    cargar(siguiente);
  };

  const abrirPlanilla = (item) => {
    setElegido(item.id);
    setPlanilla(null);
    setPlanillaAbierta(true);
    setCargandoPlanilla(true);
    setErrorPlanilla('');
    setAvisoPlanilla('');

    fetchSpecialistPlanilla(solicitanteId, item.id)
      .then((detalle) => {
        setPlanilla(detalle);
      })
      .catch((requestError) => {
        setErrorPlanilla(requestError.message || 'No se pudo abrir la planilla.');
      })
      .finally(() => {
        setCargandoPlanilla(false);
      });
  };

  const guardarPlanilla = (detalle) => {
    setGuardandoPlanilla(true);
    setErrorPlanilla('');
    setAvisoPlanilla('');

    saveSpecialistPlanilla(solicitanteId, detalle)
      .then((guardada) => {
        setPlanilla(guardada || detalle);
        setAvisoPlanilla('Planilla guardada.');
      })
      .catch((requestError) => {
        setErrorPlanilla(requestError.message || 'No se pudo guardar la planilla.');
      })
      .finally(() => {
        setGuardandoPlanilla(false);
      });
  };

  const preaprobar = () => {
    const item = lista.find((fila) => String(fila.id) === String(elegido));

    if (!item) {
      setError('Seleccione un especialista de la lista.');
      return;
    }

    if (item.en_beyond) {
      setError('Esa planilla ya tiene una cuenta en Beyond.');
      return;
    }

    if (onUsar) {
      onUsar(item);
    }
  };

  const seleccionado = lista.find((fila) => String(fila.id) === String(elegido));
  const puedePreaprobar = Boolean(seleccionado && !seleccionado.en_beyond);
  const viendoTodos = modo === 'todos';

  return (
    <div className="admin-pre-overlay" role="presentation">
      <div
        className={'admin-pre-panel' + (planillaAbierta ? ' admin-pre-panel--planilla' : '')}
        role="dialog"
        aria-modal="true"
        aria-labelledby="admin-pre-title"
      >
        <div className="admin-pre-bar">
          <h2 id="admin-pre-title">{viendoTodos ? 'Todos los especialistas' : 'Preaprobar especialistas'}</h2>
          <button type="button" className="admin-pre-close" onClick={onClose} aria-label="Cerrar">
            ×
          </button>
        </div>
        {planillaAbierta ? (
          <AdminSpecialistPlanilla
            planilla={planilla}
            cargando={cargandoPlanilla}
            error={errorPlanilla}
            onBack={() => {
              setPlanillaAbierta(false);
              setPlanilla(null);
              setErrorPlanilla('');
              setAvisoPlanilla('');
            }}
            onSave={guardarPlanilla}
            guardando={guardandoPlanilla}
            aviso={avisoPlanilla}
          />
        ) : (
          <>
            <p className="admin-muted">
              {viendoTodos
                ? 'Todas las planillas de Mi Perfil. Pulsa el nombre para ver los datos. Las pendientes se pueden preaprobar.'
                : 'Planillas de Mi Perfil que todavía no tienen cuenta en Beyond. Pulsa el nombre para ver la planilla. Preaprobar llena Crear usuario; la cuenta se crea después.'}
            </p>
            {error ? (
              <div className="admin-alert admin-alert--error" role="alert">
                {error}
              </div>
            ) : null}
            {cargando ? <p className="admin-muted">Cargando planillas…</p> : null}
            {!cargando && lista.length === 0 && !error ? (
              <p className="admin-muted">
                {viendoTodos
                  ? 'No hay planillas de especialistas en Mi Perfil.'
                  : 'No hay especialistas pendientes de Beyond.'}
              </p>
            ) : null}
            {!cargando && lista.length > 0 ? (
              <div className="admin-table-wrap">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th />
                      <th>Nombre</th>
                      <th>Edad</th>
                      <th>Especialidad</th>
                      <th>Años de experiencia</th>
                      {viendoTodos ? <th>Estado</th> : null}
                    </tr>
                  </thead>
                  <tbody>
                    {lista.map((item) => {
                      const activo = String(elegido) === String(item.id);

                      return (
                        <tr
                          key={item.id}
                          className={activo ? 'admin-pre-row--selected' : undefined}
                          onClick={() => setElegido(item.id)}
                        >
                          <td>
                            <input
                              type="radio"
                              name="preaprobar-especialista"
                              checked={activo}
                              onChange={() => setElegido(item.id)}
                              aria-label={'Seleccionar ' + item.nombre}
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              className="admin-link-btn"
                              onClick={(event) => {
                                event.stopPropagation();
                                abrirPlanilla(item);
                              }}
                            >
                              {item.nombre}
                            </button>
                          </td>
                          <td>{item.edad}</td>
                          <td>{item.especialidad}</td>
                          <td>{item.anios}</td>
                          {viendoTodos ? <td>{item.en_beyond ? 'Preaprobado' : 'Pendiente'}</td> : null}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : null}
            <div className="admin-pre-actions">
              <button
                type="button"
                className="admin-btn admin-btn--primary"
                onClick={preaprobar}
                disabled={cargando || !puedePreaprobar}
              >
                Preaprobar
              </button>
              <button
                type="button"
                className="admin-btn admin-btn--secondary"
                onClick={() => cambiarModo(viendoTodos ? 'pendientes' : 'todos')}
                disabled={cargando}
              >
                {viendoTodos ? 'Ver pendientes' : 'Consultar todos los especialistas'}
              </button>
              <button type="button" className="admin-btn admin-btn--secondary" onClick={onClose}>
                Cerrar
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminPreapproveSpecialists;
